import YesIcon from 'assets/images/yes-icon.svg';
import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';
import Logo from 'assets/images/logo.svg';
import FooterLogo from 'assets/images/footer-logo.svg';
import Theme from 'theme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
  REACT_APP_APPPOINTMENT_LINK: bookAppointmentLink,
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'machenfamilydentistry',
  tokenName: 'machenfamilydentistrySubscriberToken',
  globalClass: 'machenfamilydentistry-container',
  clientHeader,
  enableHeroButton: true,
  pricingType: 'standard-pricing',
  heroLocaleColor: 'secondary',
  skipChoosePlan: true,
  headerProps: {
    enable: true,
  },
  localeProps: {},
  homeTemplateProps: {
    heroSection: {
      variant: 2,
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      primaryButtonProps: {
        to: '/find-a-provider',
      },
      secondaryButtonProps: {
        to: '/login',
        color: 'secondary',
        variant: 'contained',
      },
      background: '/images/home-images/home-banner-img.webp',
      backgroundMobile: '/images/home-images/home-banner-img.webp',
    },
    benefitsSection: {
      variant: 6,
      columns: 3,
      alignTitle: 'center',
      alignCard: 'center',
    },
    subscriptionSection: {
      priority: 'top',
      renderAsTabsLimit:4,
      cardVariant: 1,
      tabVariant: 2,
      disableGroupSavings: true,
      carouselResponsiveItems: {
        desktop: 3,
      },
      showAddons: false,
      primaryButtonProps: {
        color: 'primary',
      },
      planCardProps: {
        buttonProps: {
          customSpace: 11,
          normalVariant: 'contained',
          normalColor: 'secondary',
          to: '/find-a-provider',
        },
      },
    },
    howItWorksSection: {
      variant: 2,
      heroImage: '/images/home-images/how-it-works.webp',
      alignTitle: 'left',
    },
    testimonialSection: {
      enable: false,
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  checkoutSection: {},
  findProviderSection: {
    variant: 1, 
    locationWrapper: 7,
    mapWrapper: 5,
    heroProps: {
      secondaryButtonProps: {
        variant: 'outlined',
        color: 'primary',
      },
    },
    iconProps: {
      url: '/images/location-marker.png',
    },
  },
  choosePlanSection: {
    sectionSubtitle: '',
    placeLogoContainerAtTop: true,
    locationLogo: Logo,
    cardVariant: 2,
    tabVariant: 2,
    planCardProps: {
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'contained',
        highlightedVariant: 'outlined',
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: true,
  },
  savingsSummary: {
    enableFooterbar: true,
    showCategoryHeaders: true,
    showPlanDiscHeader: true,
    contactSection: 'contactDetails',
  },
  faqSection: {},
  dashboardProps: {
    showBenefitsUsage: true,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  bookAppointment: {},
  footer: {
    enable: true,
    logo: FooterLogo,
  },
  loginPage: {
    bannerImage: './images/login.webp',
  },
  theme: Theme,
};

export default config;
